export const TelecomLinks = [
  {
    id: "Dashboard",
    name: "Dashboard",
    url: "/dashboard",
    root: true,
    icon: "pie_chart",
    access: false,
  },
  {
    id: "Dispatch",
    name: "Dispatch",
    url: "/dashboard/dispatch/telecom",
    icon: "headset_mic",
    root: true,
    access: false,
  },
  {
    id: "DispatchAdmin",
    name: "Dispatch Admin",
    url: "/dashboard/dispatch-admin/telecom",
    icon: "edit_note_icon",
    root: true,
    access: false,
  },
  {
    id: "ClaimsAdmin",
    name: "Claims Admin",
    icon: "edit_note_icon",
    root: true,
    access: false,
  },
  {
    parentId: "ClaimsAdmin",
    id: "ClaimLetterContacts",
    name: "Claim Letter Contacts",
    url: "/dashboard/claims-manager/contacts",
    icon: "description",
    root: false,
    access: false,
  },
  {
    parentId: "ClaimsAdmin",
    id: "LetterReasons",
    name: "Letter Reasons",
    url: "/dashboard/claims-manager/letters",
    icon: "description",
    root: false,
    access: false,
  },
  {
    id: "MyTeam",
    name: "MyTeam",
    url: "/dashboard/my-team",
    icon: "group",
    root: true,
    access: false,
  },
  {
    id: "Claims",
    name: "Claims",
    url: "/dashboard/claim/telecom",
    icon: "list_alt",
    root: true,
    access: false,
  },
  {
    id: "ClaimsQueue",
    name: "Claims Queue",
    url: "/dashboard/queues",
    icon: "group",
    root: true,
    access: false
  },
  {
    id: "MobileClaims",
    name: "Mobile Claims",
    url: "/dashboard/mobile-claims",
    icon: "phone_iphone",
    root: true,
    access: false
  },
  {
    id: "RoundRobin",
    name: "Round Robin",
    url: "/dashboard/round-robin",
    icon: "donut_large",
    root: true,
    access: false,
  },
  {
    id: "Reports",
    name: "Reports",
    icon: "description",
    root: true,
    access: false,
  },
  {
    parentId: "Reports",
    id: "CustomReports",
    name: "Custom Reports",
    url: "/dashboard/reports/custom",
    icon: "description",
    root: false,
    access: false,
  },
  {
    parentId: "Reports",
    id: "LegacyReports",
    name: "Legacy Reports",
    url: "/dashboard/reports/legacy/telecom",
    icon: "description",
    root: false,
    access: false,
  },
    {
    id: "LegalClaims",
    name: "Legal Claims",
    icon: "gavel",
    url: "/dashboard/legal-claims",
    root: true,
    access: false,
  },
  {
    id: "ResourceTools",
    name: "Resource Tools",
    icon: "emoji_objects",
    root: true,
    access: false,
  },
  {
    parentId: "ResourceTools",
    id: "KnowledgeBase",
    name: "Knowledge Base",
    icon: "",
    url: "/dashboard/resource-tools/knowledge-base",
    root: false,
    access: false,
  },
  {
    parentId: "ResourceTools",
    id: "FAQS",
    name: "FAQ's",
    icon: "",
    url: "/dashboard/resource-tools/faqs",
    root: false,
    access: false,
  },
  {
    parentId: "ResourceTools",
    id: "OPDClaimMap",
    name: "OPD Claim Map",
    icon: "",
    url: "/dashboard/resource-tools/opd-claim-map",
    root: false,
    access: false,
  },
  {
    parentId: "Ledger",
    id: "LedgerAdjustment",
    name: "Ledger Adjustments",
    icon: "history_edu",
    url: "/dashboard/ledger/telecom",
    root: true,
    access: false,
  },
];
